import { MajorProgram } from 'capability-ng-major-explorer';
import { Resource, ResourceCategory, ResourceInfo, ResourceLocation } from 'capability-ng-resources';
import { IDefineCommand } from 'core-ts-types';
import * as _4 from 'lodash';
import { IDatasource, ORM } from 'utility-ts-orm';

angular
  .module('capability-ng-favorites')
  .factory(
    'loadFavoritesCommand',
    function loadFavoritesCommandDefinition(
      $http: ng.IHttpService,
      defineCommand: IDefineCommand,
      ngResourceDatastore: IDatasource<Resource>,
      ngResourceInfoDatastore: IDatasource<ResourceInfo>,
      ngResourceLocationDatastore: IDatasource<ResourceLocation>,
      ngResourceCategoryDatastore: IDatasource<ResourceCategory>,
      ngMajorProgramDatastore: IDatasource<MajorProgram>,
      ngMajorCredentialDatastore: IDatasource<any>,
      ngMajorProgramModel: any
    ) {
      return defineCommand('loadFavoritesCommand', (deferred) => {
        $http
          .get('favorite')
          .then(({ data }: { data: any }) => {
            ngMajorProgramModel.write(data);
            ngMajorProgramDatastore.clear().write(data.program);
            ngMajorCredentialDatastore.write(data.program_credential);

            ngResourceCategoryDatastore.write(_4.get(data, 'resource.resource_category', []));
            ngResourceDatastore.clear().write(_4.get(data, 'resource.resource', []));
            ngResourceInfoDatastore.write(_4.get(data, 'resource.resource_detail', []));
            ngResourceLocationDatastore.write(_4.get(data, 'resource.location'));
            ORM.run();
            deferred.resolve();
          })
          .catch((err) => {
            deferred.reject(err);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-favorites/src/commands/load_favorites_command.ts